import { useState, useEffect } from 'react';

import './Main.css';
import './scheme.css';
import cpu from './assets/images/cpu.jpg';
import market from './assets/images/market.png';
import gamble1 from './assets/images/gamble1.png';
import trade from './assets/images/trade.png';
import guns from './assets/images/guns.png';
import jackpot from './assets/images/jackpot.png';
import leveling from './assets/images/leveling.jpg';
import steamLogo from './assets/images/steam.ico';
import discordLogo from './assets/images/discord.ico';
import birb from './assets/images/bird.png';

import Typewriter from 'typewriter-effect';
import CountUp from 'react-countup';
import ImageGallery from "react-image-gallery";

import bgVideo from './assets/videos/titsgb.webm';
import Carousel from './assets/elements/carousel';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse } from '@fortawesome/free-solid-svg-icons/faHouse';
import { faGlobe, faPeopleGroup, faStore, faTools, faUserClock, faSignal } from '@fortawesome/free-solid-svg-icons';



const images = [
  {
    original: "https://steamuserimages-a.akamaihd.net/ugc/957476389753499877/2182C1921CE1A2206E120B4B6C14128537E62B4E/?imw=5000&imh=5000&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=false",
    originalAlt: "A photo of the TitsRP Garry's Mod server running DarkRP"
  },
  {
    original: "https://steamuserimages-a.akamaihd.net/ugc/964224906622597805/073ABC4A21526DCE1F498722EDE145D8DFF9867A/?imw=5000&imh=5000&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=false",
    originalAlt: "A photo of the TitsRP Garry's Mod server running DarkRP"
  },
  {
    original: "https://steamuserimages-a.akamaihd.net/ugc/964224906622597818/7C04D9B02D52BC8A47F36FF20028786442504639/?imw=5000&imh=5000&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=false",
    originalAlt: "A photo of the TitsRP Garry's Mod server running DarkRP"
  },
  {
    original: "https://steamuserimages-a.akamaihd.net/ugc/964224906622597828/20EA4AF727F92C0B61D2338FEED3BBB381B0DC53/?imw=5000&imh=5000&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=false",
    originalAlt: "A photo of the TitsRP Garry's Mod server running DarkRP"
  },
  {
    original: "https://steamuserimages-a.akamaihd.net/ugc/964224906622597864/841D6BF0DDA2DB3220B3B827E19FA6772EEDA8F5/?imw=5000&imh=5000&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=false",
    originalAlt: "A photo of the TitsRP Garry's Mod server running DarkRP"
  },
  {
    original: "https://steamuserimages-a.akamaihd.net/ugc/964224906622597888/BE1FBDDD2AF8F9F877C43AB0A40FDD5279C8AED7/?imw=5000&imh=5000&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=false",
    originalAlt: "A photo of the TitsRP Garry's Mod server running DarkRP"
  },
  {
    original: "https://steamuserimages-a.akamaihd.net/ugc/964224906622597903/AE7135AF5885F1A8F4DD7DCC324C9EDA6C72EFA3/?imw=5000&imh=5000&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=false",
    originalAlt: "A photo of the TitsRP Garry's Mod server running DarkRP"
  },
  {
    original: "https://steamuserimages-a.akamaihd.net/ugc/964224906622597955/C950C348AB7410103ED364B8BF1B43E5C3C0DE57/?imw=5000&imh=5000&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=false",
    originalAlt: "A photo of the TitsRP Garry's Mod server running DarkRP"
  },
  {
    original: "https://steamuserimages-a.akamaihd.net/ugc/964224906622597973/F77542353D5E13C29652E084D1AF8D880B47D5C5/?imw=5000&imh=5000&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=false",
    originalAlt: "A photo of the TitsRP Garry's Mod server running DarkRP"
  },
  {
    original: "https://steamuserimages-a.akamaihd.net/ugc/964224906622597985/4C8AE2E5296FFEB573349FD39499627FAF8EFB8D/?imw=5000&imh=5000&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=false",
    originalAlt: "A photo of the TitsRP Garry's Mod server running DarkRP"
  },
  {
    original: "https://steamuserimages-a.akamaihd.net/ugc/964224906622598003/A03A75E9AED2E5172353652CC06AB0A2E05AE328/?imw=5000&imh=5000&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=false",
    originalAlt: "A photo of the TitsRP Garry's Mod server running DarkRP"
  },
  {
    original: "https://steamuserimages-a.akamaihd.net/ugc/964224906622598014/5E11554D70AAC240B9C76ED86293414C1CFB902E/?imw=5000&imh=5000&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=false",
    originalAlt: "A photo of the TitsRP Garry's Mod server running DarkRP"
  },
  {
    original: "https://steamuserimages-a.akamaihd.net/ugc/964224906622598026/5A537683AF6BBC6969A68DE20080CDFFD51F8D67/?imw=5000&imh=5000&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=false",
    originalAlt: "A photo of the TitsRP Garry's Mod server running DarkRP"
  },
  {
    original: "https://steamuserimages-a.akamaihd.net/ugc/964224906622598042/C2AABE2CCAC7BB9205F30C7BD254797B0F9C56B0/?imw=5000&imh=5000&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=false",
    originalAlt: "A photo of the TitsRP Garry's Mod server running DarkRP"
  },
  {
    original: "https://steamuserimages-a.akamaihd.net/ugc/964224906622598065/982660E9EEAF407ECFCDC5F437D8F053B464F927/?imw=5000&imh=5000&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=false",
    originalAlt: "A photo of the TitsRP Garry's Mod server running DarkRP"
  },
  {
    original: "https://steamuserimages-a.akamaihd.net/ugc/964224906622598090/C73BD2B5D6B11A1ABC5B3F7D1F2D68B33A8E7C9E/?imw=5000&imh=5000&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=false",
    originalAlt: "A photo of the TitsRP Garry's Mod server running DarkRP"
  },
  {
    original: "https://steamuserimages-a.akamaihd.net/ugc/957476389753500604/31BB4F84961662757FE5DE27AFEF869805DFE11A/?imw=5000&imh=5000&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=false",
    originalAlt: "A photo of the TitsRP Garry's Mod server running DarkRP"
  }
]

const p2pImages = [
  {original: guns, originalAlt: "A photo of the TitsRP Garry's Mod server running DarkRP"},
  {original: trade, originalAlt: "A photo of the TitsRP Garry's Mod server running DarkRP"},
  {original: market, originalAlt: "A photo of the TitsRP Garry's Mod server running DarkRP"},
  {original: gamble1, originalAlt: "A photo of the TitsRP Garry's Mod server running DarkRP"},
  {original: jackpot, originalAlt: "A photo of the TitsRP Garry's Mod server running DarkRP"},
]

function Main() {

  const [playtime, setPlaytime] = useState(0);
  const [players, setPlayers] = useState(0);
  const [fps, setFps] = useState(0);
  const [playercount, setPlayercount] = useState(0);
  const [serverOnline, setServerOnline] = useState(null);

  useEffect(() => {
    fetch('https://titsrp.com/api/server/analytics/playtime')
      .then(blob => blob.json())
      .then(data => {
        setPlaytime(data.total.total_playtime);
      })
      .catch(e => {
        console.log(e);
        return e;
      }
    )

    fetch('https://titsrp.com/api/server/getplayercount')
      .then(blob => blob.json())
      .then(data => {
        setPlayers(data.total_players);
      })
      .catch(e => {
        console.log(e);
        return e;
      }
    )

    fetch('https://titsrp.com/api/server/analytics/fps')
      .then(blob => blob.json())
      .then(data => {
        setFps(data[0].average)
      })
      .catch(e => {
        console.log(e);
        return e;
      }
    )

    fetch('https://api.battlemetrics.com/servers/22160069')
      .then(blob => blob.json())
      .then(data => {
        setPlayercount(data.data.attributes.players)
        setServerOnline(data.data.attributes.status === 'online')
      })
      .catch(e => {
        console.log(e);
        setServerOnline(false);
        return e;
      }
    )

  }, []);

  useEffect(() => {
    if (serverOnline === null) return;

    const schemaTag = document.getElementById('gameserver-schema');
    if (!schemaTag) return;

    try {
      const data = JSON.parse(schemaTag.textContent);
      data.serverStatus = serverOnline
        ? 'https://schema.org/GameServerOnline'
        : 'https://schema.org/GameServerOffline';

      if (serverOnline) {
        data.playersOnline = playercount;
      } else {
        delete data.playersOnline;
      }

      schemaTag.textContent = JSON.stringify(data);
    } catch (e) {
      console.log(e);
    }
  }, [serverOnline, playercount]);

  const VideoIDs = [
    "aXlJIJ2JXA0",
    "b0U3pC8ti0E",
    "Fv6VT2HweAw",
    "d8Qo8tvKkVM",
    "oBZ4hxa3nsw",
    "Tt0gkNsttnw",
    "oBZ4hxa3nsw",
    "SMWuxCOhWFo",
    "8jOARrWh70o",
    "z9iuBQXXgNU",
    "NO763w4Sl1k"
  ]

  function GetRandomVideoID() {
    return VideoIDs[Math.floor(Math.random() * VideoIDs.length)]
  }

  function ReturnPlayercount() {
    if (playercount > 0) {
      return [playercount, "Players Online", faGlobe]
    }
    return [fps, "Average FPS", faSignal]
  }

  // CSS-only glow: update CSS variables on mouse move
  function handleLinksMouseMove(e) {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width;
    const y = (e.clientY - rect.top) / rect.height;
    e.currentTarget.style.setProperty('--glow-x', `${x * 100}%`);
    e.currentTarget.style.setProperty('--glow-y', `${y * 100}%`);
  }

  function handleLinksMouseLeave(e) {
    e.currentTarget.style.setProperty('--glow-x', '50%');
    e.currentTarget.style.setProperty('--glow-y', '50%');
  }

  return (
    <div className="App" onScroll={(e) => {
      const arrowElement = document.querySelector(".down-arrow");
      if (arrowElement) {
        arrowElement.style.display = e.target.scrollTop > 0 ? "none" : "block";
      }
    }}>
      <video className='background' allowFullScreen="false" playsinline webkit-playsinline autoPlay loop muted><source src={bgVideo} type="video/webm"></source></video>
      <div className='navigation'>
        <div id='logoWrap'>
          <div style={{display:'flex', flexDirection:'inline'}}><img className='birb' src={birb} alt='A smiling cartoon Tit bird with navy and white body on a hot red background'></img><span id='title'><span style={{ color: '#E54747', marginRight: '7px' }}>T</span>its<span style={{marginLeft: '20px' }}>RP</span></span></div>
          <span id='subtitle'>
            <Typewriter
              options={{
                delay: 80,
              }}
              onInit={(typewriter) => {
                typewriter.typeString(`"Where your computer doesn't explode..."`)
                  .pauseFor(1000)
                  .deleteAll()
                  .typeString(`"Where memes become dreams!"`)
                  .pauseFor(1000)
                  .deleteAll()
                  .typeString(`"The meme machine, since 2015!"`)
                  .start()
              }}
            />
          </span>
        </div>
        <div className='navContain'>
          <div
            className='links'
            onMouseMove={handleLinksMouseMove}
            onMouseLeave={handleLinksMouseLeave}
            style={{ '--glow-x': '50%', '--glow-y': '50%' }}
          >
            <a href='https://forums.titsrp.com'><span style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}><FontAwesomeIcon className='navLinkIcon' icon={faHouse} />FORUMS</span></a>
            <a href='https://titsrp.com/dashboard'><span style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}><FontAwesomeIcon className='navLinkIcon' icon={faTools} />DASHBOARD</span></a>
            <a href='https://titsrp.com/store'><span style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}><FontAwesomeIcon className='navLinkIcon' icon={faStore} />SHOP</span></a>
            <a href='https://discord.gg/ceN6ytn'><span style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}><img alt='Discord logo' className='navLinkIcon' style={{height: '19px'}} src={discordLogo} />DISCORD</span></a>
            <a href='https://steamcommunity.com/groups/TitsRP'><span style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}><img alt='Steam logo' className='navLinkIcon' style={{height: '19px'}} src={steamLogo} />STEAM</span></a>

            <div className='socials'>
              <a href='https://discord.gg/ceN6ytn' id='discord'><img alt='Discord logo' src={discordLogo}></img></a>
              <a href='https://steamcommunity.com/groups/TitsRP' id='steam'><img alt='Steam logo' src={steamLogo}></img></a>
            </div>

          </div>
        </div>
        <div className='JoinButton' onMouseMove={handleLinksMouseMove} onMouseLeave={handleLinksMouseLeave} style={{ '--glow-x': '50%', '--glow-y': '50%' }} onClick={() => window.location.href = 'steam://connect/193.243.190.39:27015'}><span style={{ display: 'flex', alignItems: 'center' }}><img style={{ marginRight: '30px', width: '29px' }} alt='Steam logo' src={steamLogo}></img>CONNECT</span></div>
      </div>

      <div className='stats'>
        <div id='stat' onMouseMove={handleLinksMouseMove} onMouseLeave={handleLinksMouseLeave}><div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}><FontAwesomeIcon icon={faPeopleGroup} /><span className='countWrap' ><CountUp id='countup' end={players} /><span id='statSub'>Total Players</span></span></div></div>
        <div id='stat' onMouseMove={handleLinksMouseMove} onMouseLeave={handleLinksMouseLeave}><div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}><FontAwesomeIcon icon={faUserClock} /><span className='countWrap'><CountUp id='countup' end={Math.floor(playtime / 3600)} /><span id='statSub'>Hours Played</span></span></div></div>
        <div id='stat' onMouseMove={handleLinksMouseMove} onMouseLeave={handleLinksMouseLeave}><div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}><FontAwesomeIcon icon={ReturnPlayercount()[2]} /><span className='countWrap'><CountUp id='countup' end={ReturnPlayercount()[0]} /><span id='statSub'>{ReturnPlayercount()[1]}</span></span></div></div>
      </div>

      <div className='mainBodyWrapper'>
         
          <div className='headerImages'>
            <iframe
              src={"https://www.youtube.com/embed/" + GetRandomVideoID()}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen>
            </iframe>
          </div>
      </div>

      

      <div className='mainBody'>
        <Carousel scrollDirection="left"/>
        <Carousel scrollDirection="right"/>
      </div>

      

      <div className='copyright' style={{ margin: '40px', marginBottom: '40px', textAlign: 'center' }}>© {new Date().getFullYear()} TitsRP 🇺🇸 </div>

    </div>

  );
}

export default Main;
